import {COINS_TO_WIN_POINTS_CONVERSION} from "../../configs/game";
import {ENLIGHTENED_COINS_TO_WIN_POINTS_CONVERSION} from "../../configs/factions/enlightened";
import {KEY_POINT_TOKENS} from "../../constants/tokens";
import {FACTIONS} from "../../constants/factions";
import {isPlayerFaction} from "../factions/isPlayerFaction";
import {compareGameResults} from "./compareGameResults";

/**
 * Итоговые очки игрока, если бы партия закончилась прямо сейчас: победные
 * очки + монеты по курсу конвертации (у просвещенных курс льготный, 1:1)
 */
export function getPlayerFinalWinPoints(player) {
  const coinsToWinPointsConversion = isPlayerFaction(player, FACTIONS.ENLIGHTENED)
    ? ENLIGHTENED_COINS_TO_WIN_POINTS_CONVERSION
    : COINS_TO_WIN_POINTS_CONVERSION;
  return player.winPoints + Math.floor(player.coins / coinsToWinPointsConversion);
}

function countCitiesKeyPointTokens(cities, tokenType) {
  return cities.reduce((total, city) => total + (city[tokenType] || []).length, 0);
}

/**
 * Итоги партии: игроки с итоговыми очками, отсортированные по месту (первый —
 * победитель). Тем же порядком считаются и промежуточные места в итогах раунда
 * (см. RoundEndModal), поэтому место по концу последнего раунда совпадает с
 * местом в итогах матча
 */
export function buildGameResults(players, citiesCache) {
  return players.map((player) => {
    const playerCities = citiesCache[player.color] || [];

    return {
      id: player.id,
      color: player.color,
      finalWinPoints: getPlayerFinalWinPoints(player),
      // Тай-брейки при равенстве finalWinPoints (порядок — в compareGameResults)
      income: player.winPoints + player.coins / 2,
      superRuinsCount: countCitiesKeyPointTokens(playerCities, KEY_POINT_TOKENS.SUPER_RUINS),
      ruinsCount: countCitiesKeyPointTokens(playerCities, KEY_POINT_TOKENS.RUINS),
      superMinesCount: countCitiesKeyPointTokens(playerCities, KEY_POINT_TOKENS.SUPER_MINE),
      minesCount: countCitiesKeyPointTokens(playerCities, KEY_POINT_TOKENS.MINE),
    };
  }).sort(compareGameResults);
}
